import theme from 'shared/assets/style/theme';

const Styles = {
  modalStyle: {
    width: '100vw',
    height: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 52vmin',
  },
  socialModalStyle: {
    width: '100vw',
    height: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 0',
  },
  SocialModalContainerStyle: {
    height: '40vh',
    width: '100%',
    marginTop: '-1vw',
    marginBottom: '-1vw',
    display: 'flex',
    flexDirection: 'column',
  },
  modalContainerStyle: {
    height: '60vh',
    width: '100%',
    marginTop: '-1vw',
    marginBottom: '-1vw',
  },
  titleStyle: {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.common[1],
    textTransform: 'uppercase',
  },
  modalMainBodyStyle: {
    width: '700px',
  },
  markImage: {
    width: '12px',
    height: '12px',
  },
};

export default Styles;
